import Spinner from 'spin';
import DomToImage from 'dom-to-image';
import Screenshot from '../../partials/components/screenshot/screenshot';

const pollOptions = $('input[type="radio"][name="poll__option"]');
const submitBtn = $('.poll__submit');
let pollVote;
const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
const localhostAPIURLs = {
  geral: 'http://localhost:8000',
  votos: 'http://localhost:8000',
};

const apiToUse = isLocalhost ? localhostAPIURLs : ENV_URLS; // eslint-disable-line

pollOptions.change((e) => {
  pollVote = e.target.dataset.optionId;
  submitBtn[0].removeAttribute('disabled');
});

submitBtn.click(() => {
  fetch(`${apiToUse.votos}/votes/guia/`, {
    method: 'POST',
    body: JSON.stringify({
      votos: [{ respostaId: pollVote, posicao: null }],
    }),
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  }).then(response => response);

  Screenshot.openModal({
    outerWrapper: '.img-share',
    appendArea: '.container-img-share',
    printWrapper: '.to-share',
    addClassOnClone: 'to-share',
    height: $('.img-share').height(),
    width: $('.img-share').width(),
    filename: 'meu-campeão.jpg',
  });
  $('.poll__wrapper').addClass('voted');
  $('.percent-votes').fadeIn();
});

// JS enquete Classificacao

const $bounds = $('[data-classifique]');
const $classifiqueEquipes = $('[data-classifique-equipe]');
const $classifiqueDrop = $('[data-classifique-drop-posicao]');
const $modal = $('[data-modal]');
const $modalEquipe = $('[data-modal-equipe]');
const $reiniciar = $('[data-classifique-reiniciar]');
const $finalizar = $('[data-classifique-finalizar]');
const $salvarImagem = $('[data-classifique-salvar-imagem]');
const $votacao = $('.classifique__drop');
const dadosEnvioImagem = {};
const totalParticipantes = $classifiqueEquipes.length;
const $optionPollChampion = $('.option__input');

// configura objeto de envio de imagem
for (let i = 1; i <= totalParticipantes; i += 1) {
  dadosEnvioImagem[i] = '';
}

const completo = () => {
  let response = true;
  $.each(dadosEnvioImagem, (key, val) => {
    if (val === '') {
      response = false;
    }
  });

  return response;
};

const mudaAtivados = (ativa, idResposta, inativa, drop, imagem) => {
  // reativa propriedades inativas dependendo da escolha
  if (inativa !== '') {
    $(`[data-classifique-equipe-inativa="${inativa}"]`)
      .css('display', 'none');

    $(`[data-classifique-equipe="${inativa}"]`)
      .css('display', 'inline-block');

    $(`[data-modal-equipe="${inativa}"]`)
      .removeClass('classifique__modal-equipe--inativa');
  }

  // coloca a imagem dentro da caixa e marca quem está lá dentro
  $(`[data-classifique-drop-posicao="${drop}"]`)
    .attr('data-classifique-drop-equipe', ativa)
    .attr('data-resposta-id', idResposta)
    .html(`<img src="${imagem}">`);

  // apaga o clube escolhido
  $(`[data-classifique-equipe="${ativa}"]`)
    .css('display', 'none');

  // apresenta a versão inativa que não arrasta
  $(`[data-classifique-equipe-inativa="${ativa}"]`)
    .css('display', 'inline-block');

  $(`[data-modal-equipe="${ativa}"]`)
    .addClass('classifique__modal-equipe--inativa');

  // salva imagem no objeto de envio de geração
  dadosEnvioImagem[Number(drop)] = ativa;

  // aqui entra a função de lista completa
  if (completo()) {
    $finalizar.removeClass('botao--inativo');
    $finalizar.css('pointer-events', 'auto');
  }
};

// função imagem dropada
const dropEquipe = function dropEquipe($target, i) {
  const $drop = $(`[data-classifique-drop-posicao="${i}"]`);
  const posicao = $drop.attr('data-classifique-drop-posicao');
  const $imgShare = $(`[data-posicao="${posicao}"]`);
  const urlImagem = $target.find('img').attr('src');

  mudaAtivados(
    $target.attr('data-classifique-equipe'),
    $target.attr('data-option-id'),
    $drop.attr('data-classifique-drop-equipe'),
    i,
    urlImagem);

  $imgShare.css('background-image', `url("${urlImagem}")`);
};

// função de drag completa
const onDragEnd = function onDragEnd() {
  const $target = $(this.target);

  for (let i = 1; i <= totalParticipantes; i += 1) {
    if (this.hitTest(`[data-classifique-drop-posicao="${i}"]`, '50%')) {
      dropEquipe($target, i);
    }
  }

  window.TweenLite.to($target, 1, { x: 0, y: 0 });
};

// ativa o drag
window.Draggable.create($classifiqueEquipes, {
  bounds: $bounds,
  type: 'x,y',
  autoScroll: true,
  onDragEnd,
});

let posicaoClicada;

// funções de classificação com Click por modal
const clickDrop = (e) => {
  if (!(completo())) {
    const $target = $(e.currentTarget);
    posicaoClicada = $target.attr('data-classifique-drop-posicao');
    $modal.fadeIn('fast');
  }
};

const clickModalEquipe = (e) => {
  const $target = $(e.currentTarget);

  if (!$target.is('.classifique__modal-equipe--inativa')) {
    const $drop = $(`[data-classifique-drop-posicao="${posicaoClicada}"]`);
    const posicao = $drop.attr('data-classifique-drop-posicao');
    const $imgShare = $(`[data-posicao="${posicao}"]`);
    const urlImagem = $target.find('img').attr('src');

    mudaAtivados(
      $target.attr('data-modal-equipe'),
      $target.attr('data-option-id'),
      $drop.attr('data-classifique-drop-equipe'),
      posicaoClicada,
      urlImagem);

    $modal.fadeOut('fast');
    $imgShare.css('background-image', `url("${urlImagem}")`);
  }
};

$classifiqueDrop.click(clickDrop);
$modalEquipe.click(clickModalEquipe);

// reiniciar as imagens
const clickReiniciar = () => {
  $('[data-classifique-equipe-inativa]')
    .css('display', 'none');

  $classifiqueEquipes
    .css('display', 'inline-block');

  $modalEquipe
    .removeClass('classifique__modal-equipe--inativa');

  $classifiqueDrop
    .attr('data-classifique-drop-equipe', '')
    .html('');

  // zera objeto de envio de imagem
  for (let i = 1; i <= totalParticipantes; i += 1) {
    dadosEnvioImagem[i] = '';
  }

  $finalizar
    .addClass('botao--inativo')
    .fadeIn()
    .css('display', 'inline-block');

  $salvarImagem
    .hide();
};

$reiniciar.click(clickReiniciar);


// função de finalização
const clickFinalizar = () => {
  const votos = [];

  $.each($votacao, (key, val) => {
    const voto = {
      respostaId: $(val).children('.classifique__drop-equipe').attr('data-resposta-id'),
      posicao: $(val).children('.classifique__drop-posicao').attr('n'),
    };
    votos.push(voto);
  });

  // Se completo realiza a ação
  if (completo()) {
    const jsonVotos = JSON.stringify({ votos });
    // apaga o botão de finalizar e mostra o de salvar imagem
    $finalizar.css('pointer-events', 'none');
    $finalizar.hide();

    new Spinner({
      color: '#3b9c00',
      lines: 8,
      className: 'loading-spinner',
    }).spin($('[data-botoes-finais]')[0]);
    $.ajax({
      type: 'POST',
      url: `${apiToUse.votos}/votes/guia/`,
      data: jsonVotos,
      success() {
        $('.loading-spinner').fadeOut();
        Screenshot.openModal({
          outerWrapper: '.img-share',
          appendArea: '.container-img-share',
          printWrapper: '.to-share',
          addClassOnClone: 'to-share',
          height: $('.img-share').height(),
          width: $('.img-share').width(),
          filename: 'minha-classificação.jpg',
        });
        $('.loading-spinner').fadeOut(200, () => {
          $('.loading-spinner').remove();
          $finalizar.show();
          $finalizar.addClass('botao--inativo');
        });
      },
    });
  }
};

$finalizar.click(clickFinalizar);

// função de salvar a imagem
const clickSalvarImagem = () => {
  $('.img-share')
    .clone()
    .addClass('to-share')
    .appendTo('.container-img-share');
  return DomToImage.toJpeg($('.to-share')[0], {
    quality: 1,
    bgcolor: '#fff',
    height: $('.img-share').height(),
    width: $('.img-share').width(),
  }).then((dataUrl) => {
    const link = document.createElement('a');
    link.download = 'minha-classificacao.jpeg';
    link.href = dataUrl;
    link.click();
    $('.img-share.to-share').remove();
  });
};

$salvarImagem.click(clickSalvarImagem);

const clickOptionPollChampion = (e) => {
  const imageOptionSelected = $(e.target).next().attr('src');
  const nameOptionSelected = $(e.target).next().attr('title');
  const shieldParticipantShare = $('.participant-shield');
  const nameParticipantShare = $('.name-participant');

  shieldParticipantShare.attr('src', imageOptionSelected);
  nameParticipantShare.text(nameOptionSelected);
};

$optionPollChampion.click(clickOptionPollChampion);



// WEBPACK FOOTER //
// local_static/templates/guias/2018/assets/scripts/pollModule.js